import { useMemo } from 'react'

const useQuery = () =>
  useMemo(
    () => new URLSearchParams(window.location.search),
    [window.location.search]
  )

export default useQuery
